<template>
  <div>
    <input :id="id" :name="name" type="date" :value="modelValue" :readonly="readonly" @change="emitValue">
  </div>
</template>

<script>
  export default {
    props: {
      id: String,
      name: String,
      readonly: Boolean,
      modelValue: String,
    },

    data(){
      return {

      }
    },

    methods: {
      emitValue($event){
        var emitted_value = $event.target.value!=="" ? $event.target.value : null;
        this.$emit('update:modelValue', emitted_value);
      },
    }
  }
</script>